export default {
  'app.pwa.offline': '当前处于离线状态',
  'app.pwa.serviceworker.updated': '有新内容',
  'app.pwa.serviceworker.updated.hint': '请点击"刷新"按钮或者手动刷新页面',
  'app.pwa.serviceworker.updated.ok': '刷新',
  'app.updateCheck.title': '更新检查',
  'app.updateCheck.backend': '后端',
  'app.updateCheck.frontend': '前端',
  'app.updateCheck.upToDate': '已是最新版本',
  'app.updateCheck.newVersionAvailable': '发现 {count} 个新版本可用',
  'app.updateCheck.allUpToDate': '所有组件均为最新版本',
  'app.updateCheck.viewRelease': '查看发布详情',
  'app.updateCheck.recheck': '重新检查',
  'app.updateCheck.close': '关闭',
  'app.updateCheck.failed': '检查更新失败，请稍后重试',
};
